module.exports = __webpack_public_path__ + "img/419.49dcba77.png";